import { useMemo } from 'react'

import NumericOperatorInput from '@components/NumericOperatorInput/NumericOperatorInput'
import { UrlUpdateType } from 'use-query-params'

type Props = {
	value: string | null
	updateFilters: (changes: any, updateTypeOverride?: UrlUpdateType) => void
}

export default function Qty({ value, updateFilters }: Props) {
	const formattedValue = useMemo(() => {
		if (!value) return null
		const [operator, qty] = value.split('.')
		return { operator, value: qty }
	}, [value])

	const handleChange = (value: { operator: string; value: string } | null) => {
		if (value) {
			updateFilters({ qty: `${value.operator}.${value.value}` })
		} else {
			updateFilters({ qty: null })
		}
	}

	return (
		<NumericOperatorInput
			fullWidth
			size="small"
			label="Qty"
			value={formattedValue}
			onChange={handleChange}
		/>
	)
}
